<template>
  <section
    class="flex flex-col items-center justify-center py-14 px-10 lg:w-3/4 mx-auto"
  >
    <check-icon size="h-32 w-32" />
    <p class="text-sm lg:text-base font-bold mt-2 mb-4">Swapping Successful!</p>
    <p
      style="word-break: normal"
      class="text-xs font-light w-full text-center leading-loose"
    >
      Your swap has been completed and sent successfully to the specified
      beneficiary address.
    </p>
    <el-button
      @click="goToSwapTransactions"
      class="bg-primary px-4 lg:py-3.5 rounded-lg mt-10 mb-4 text-white text-xs lg:text-sm w-full font-normal"
      >View Transaction</el-button
    >
  </section>
</template>

<script>
export default {
  components: {
    CheckIcon: () => import('@/assets/v2/icons/CheckIcon.vue')
  },
  methods: {
    goToSwapTransactions () {
      this.$store.dispatch('transactions/activeFilter', 'swap')
      this.$router.push('/transactions')
    }
  },
  destroyed () {
    this.$store.dispatch('bridge/clearMainSwapState')
  }
}
</script>
